type TaskAction = () => Promise<void>;

type Task = {
  id: string;
  action: TaskAction;
};

export default class TaskManager {
  private static concurrency: number = 10;
  private static queue: Task[] = [];
  private static taskMap: Map<string, Task> = new Map();
  private static activeCount = 0;
  private static isRunning = false;

  static setConcurrency(n: number) {
    this.concurrency = Math.max(1, n);
    this.runNext();
  }

  static enqueue(id: string, action: TaskAction) {
    if (this.taskMap.has(id)) {
      this.cancel(id);
    }
    const task: Task = { id, action };
    this.queue.push(task);
    this.taskMap.set(id, task);
    this.runNext();
  }

  static cancel(id: string) {
    this.queue = this.queue.filter((task) => task.id !== id);
    this.taskMap.delete(id);
  }

  static clear() {
    this.queue = [];
    this.taskMap.clear();
  }

  private static async runNext() {
    if (this.isRunning) return;
    this.isRunning = true;

    while (this.activeCount < this.concurrency && this.queue.length > 0) {
      const task = this.queue.shift();
      if (!task) continue;

      this.taskMap.delete(task.id);
      this.activeCount++;

      try {
        await task.action();
      } catch (err) {
        console.error(`[TaskQueue] Task ${task.id} failed:`, err);
      }

      this.activeCount--;
    }

    this.isRunning = false;

    if (this.queue.length > 0) {
      this.runNext();
    }
  }
}
